exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pdf-thumbnail[data-v-3404fe86] {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}", ""]);

// exports
